export default "__VITE_ASSET__M48SeYtV__"